import messages from './messages';
import dateTimeFormats from './dateTimeFormats';

export default {
  config: {
    messages,
    dateTimeFormats,
  },
  getUserLocale() {
    let [lang] = navigator.language.toLowerCase().split('-');
    lang = Object.keys(messages).indexOf(lang) > -1 ? lang : 'en';
    return lang;
  },
};



// WEBPACK FOOTER //
// ./src/i18n/index.js